module.exports = __webpack_public_path__ + "media/images/static/consult/img04-bb571d027acca892a50c341d047bf1df.png";